module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"error-retrieving-stations":"Se produjo un error buscando las estaciones Recyco. Por favor recargue la aplicación y si el problema persiste, intente nuevamente más tarde."},"en":{"error-retrieving-stations":"An error ocurred while finding Recyco stations. Please reload the app and if the problem persists, try again later."}}')
  delete Component.options._Ctor
}
